export default {
  ROLLBAR_ACCESS_TOKEN: process.env.ROLLBAR_ACCESS_TOKEN,
  BACKEND_URL: process.env.VUE_APP_BACKEND_HTTPS_BASE_URL,
  API_URL: process.env.VUE_APP_BACKEND_API_URL,
  GOOGLE_RECAPTCHA_API: process.env.VUE_APP_GOOGLE_RECAPTCHA_API,
};
